/**
 * Switches for document-area features that are not ready to show.
 *
 * - `comments`: the toolbar's Comments button (card 2.1). Documents have no
 *   comment UI yet, so the button stays hidden until one exists.
 */
export const DOC_FLAGS = Object.freeze({
  comments: false,
});
